
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import StaticPageTemplate from '@/components/StaticTemplate';
import useTranslation from 'next-translate/useTranslation';
import type { GetStaticProps } from 'next';
import ForSection from '@/components/Services/ForSection';
import {
  HiOutlineArrowsRightLeft,
  HiOutlineBookmarkSquare,
  HiOutlineCheckBadge,
  HiOutlineComputerDesktop,
  HiOutlineGlobeAlt,
  HiOutlinePencilSquare,
} from 'react-icons/hi2';
import WorkSection from '@/components/Services/WorkSection';
import ExpertiseSection from '@/components/Services/Expertise';
import ContactSection from '@/components/Services/Contact';

function MyPage() {
  const { t } = useTranslation();
  const title = t('services:Global Marketing.title');
  const subtitle = t('services:Global Marketing.subtitle');

  const sellerBlocks = [
    {
      title: t('services:Global Marketing.blockSell1'),
      icon: <HiOutlineComputerDesktop className='text-2xl' />,
    },
    {
      title: t('services:Global Marketing.blockSell2'),
      icon: <HiOutlineGlobeAlt className='text-2xl' />,
    },
    {
      title: t('services:Global Marketing.blockSell3'),
      icon: <HiOutlineArrowsRightLeft className='text-2xl' />,
    },
  ];
  const buyerBlocks = [
    {
      title: t('services:Global Marketing.blockBuy1'),
      icon: <HiOutlineCheckBadge className='text-2xl' />,
    },
    {
      title: t('services:Global Marketing.blockBuy2'),
      icon: <HiOutlineBookmarkSquare className='text-2xl' />,
    },
    {
      title: t('services:Global Marketing.blockBuy3'),
      icon: <HiOutlinePencilSquare className='text-2xl' />,
    },
  ];

  const components = [
    <ForSection
      sellText={t('services:Global Marketing.sellForText')}
      buyText={t('services:Global Marketing.buyForText')}
      key={'for'}
      buyerBlocks={buyerBlocks}
      sellerBlocks={sellerBlocks}
    />,
    <WorkSection
      sellText={t('services:Global Marketing.sellingProcess')}
      buyText={t('services:Global Marketing.buyingProcess')}
      key={'work'}
    />,
    <ExpertiseSection
      text={t('services:Global Marketing.expertise')}
      key={'expertise'}
    />,
    <ContactSection key={'contact'} />,
  ];

  return (
    <StaticPageTemplate
      title={title}
      service={true}
      subtitle={subtitle}
      components={components}
    />
  );
}

 const _getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      hasContainer: false,
    },
  };
};

export default MyPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/services/global-marketing',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  